/**
 * Per-tab marker that the user accepted a startup admin invite (MYN-311) and
 * should land on Create Startup after signing in, even across the
 * authenticator-setup and sign-in hops in between. Cleared once the startup
 * exists. Losing it (a new tab) only costs the redirect: the dashboard already
 * offers Create Startup to anyone without one.
 */
const KEY = 'mnr.startupInviteLanding';

/** Remember that Create Startup is the next stop for this tab. */
export function markStartupInviteLanding(): void {
  try {
    sessionStorage.setItem(KEY, '1');
  } catch {
    // Storage blocked (private mode): the dashboard's Create Startup CTA still works.
  }
}

/** Whether this tab accepted a startup admin invite and has not created the startup yet. */
export function hasStartupInviteLanding(): boolean {
  try {
    return sessionStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/** Forget the marker once the startup is created. */
export function clearStartupInviteLanding(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    // Nothing stored to clear.
  }
}
